import React  from 'react'
import WrapedSpinner from '../../../components/Spinner/WrapedSpinner';
import RequestItem from './RequestItem';
import { useState } from 'react';
import UserModal from '../modals/UserModal';
import DecisionModal from './DecisionModal';
import { useGetOrgVerifyRequestsQuery } from '../../../redux/apiSlices/organizationSlice';
import OrganizationModal from '../modals/OrganizationModal';

function OrgVerificationRequests() {



  




  const {
    data:requests,
    isFetching,
  } = useGetOrgVerifyRequestsQuery()

  const [showDecisionModal, setShowDecisionModal] = useState(false)
  const [decision, setDecision] = useState('')

  const [selectedRequest, setSelectedRequest] = useState(null)


  const [showUserModal, setShowUserModal] = useState(false)

  
  const handleShowDecisionModal = (rq, decision) => {
    setSelectedRequest(rq)
    setDecision(decision)
    setShowDecisionModal(true)
  }



  const handleShowUserModal = (rq) => {
    setSelectedRequest(rq)
    setShowUserModal(true)
  }















  return (
	<>
	<OrganizationModal
      showModal={showUserModal}
      handleCloseModal={()=> setShowUserModal(false)}
      selectedRequest={selectedRequest}
      />
      <DecisionModal
      showModal={showDecisionModal}
      handleCloseModal={()=> setShowDecisionModal(false)}
      selectedRequest={selectedRequest}
      decision={decision}
      handleNote={()=>{}}
      isLoading={false} 
      note=''
      bodyText={decision === 'approved' ? 'يرجى التأكد من صحة رقم السجل التجاري وصيغة رقم الجوال قبل تأكيد عملية توثيق الحساب' : 'هل أنت متأكد من رغبتك برفض توثيق الحساب؟'}
      />
    <div class="page-content-wrapper border">

		{/* <!-- Title --> */}
		<div class="row mb-3">
			<div class="col-12 d-sm-flex justify-content-between align-items-center">
				<h1 class="h3 mb-2 mb-sm-0">طلبات التوثيق للمؤسسات</h1>
			</div>
		</div>



		{/* <!-- Card START --> */}
		<div class="card bg-transparent border">



			{/* <!-- Card body START --> */}
			<div class="card-body">
				{/* <!-- Course table START --> */}
				<div class="table-responsive border-0 rounded-3">
					{/* <!-- Table START --> */}
					<table class="table table-dark-gray align-middle p-4 mb-0 table-hover">
						{/* <!-- Table head --> */}
						<thead>
							<tr>
								<th scope="col" class="border-0 rounded-start">مقدم الطلب</th>
								<th scope="col" class="border-0">تاريخ التقديم</th>
								<th scope="col" class="border-0">القرار</th>
							</tr>
						</thead>
						
							{isFetching ?<tbody><tr><td><WrapedSpinner/></td></tr></tbody> :
						<tbody>
							
							{!requests?.length ? 
              <tr><td><p className='my-4 text-center'>لا توجد طلبات جديدة</p></td></tr> :
              requests?.map((rq,i)=> {
	
					return (
						<RequestItem
								 key={rq.id}
								 request={rq}
								 handleShowDecisionModal={handleShowDecisionModal}
								 handleShowUserModal={handleShowUserModal}
								 />
					)
				
			  })}





						</tbody>
}
						{/* <!-- Table body END --> */}
					</table>
					{/* <!-- Table END --> */}
				</div>
				{/* <!-- Course table END --> */}
			</div>
			{/* <!-- Card body END --> */}


		</div>
		{/* <!-- Card END --> */}
	</div>
	</>
  )
}

export default OrgVerificationRequests